<template>
  <base-modal
    id="BaseImageModal"
    ref="modal__base-image"
    class="modal__image"
    size="xl"
    :show.sync="$show"
    hide-header
    hide-footer
  >
    <slick ref="slick" :key="slickKey" :options="slickOptions" @afterChange="handleAfterChange">
      <div
        v-for="(item, index) in images"
        :key="item.id || index"
        class="d-flex justify-content-end"
      >
        <v-lazy-image
          :key="`img__item-${item.id}`"
          :ref="`img__item-${item.id}`"
          :src="item.url"
          class="img__item"
          src-placeholder="https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.webp"
          @load="onLoaded"
          @error.native="onLoadError"
        ></v-lazy-image>

        <font-awesome-icon
          :ref="`img__icon-close-${item.id}`"
          icon="xmark"
          size="lg"
          class="icon__xmark"
          @click="hide"
        />
      </div>
    </slick>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
import Slick from 'vue-slick';

export default {
  name: 'BaseImageModal',

  components: {
    BaseModal,
    Slick
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    images: {
      type: Array,
      default: () => []
    },

    indexActive: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      loaded: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    $indexActive: {
      get() {
        return this.indexActive;
      },

      set(v) {
        this.$emit('update:indexActive', v);
      }
    },

    slickKey() {
      return 'slick-' + this.images.map(({ id }) => id).join('-');
    },

    slickOptions() {
      const { $indexActive } = this;

      return {
        accessibility: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: $indexActive,
        lazyLoad: 'ondemand',
        speed: 500,
        dots: true,
        arrow: true,
        prevArrow: '<button type="button" class="slick-prev btn__prev-slide">Previous</button>',
        nextArrow: '<button type="button" class="slick-next btn__next-slide">Next</button>',
        adaptiveHeight: true
      };
    }
  },

  watch: {
    images: {
      handler: 'reInitSlick'
    },

    show: {
      handler($v) {
        if ($v) {
          this.reInitSlick();
        }
      }
    }
  },

  methods: {
    hide() {
      this.$bvModal.hide(`BaseImageModal`);
    },

    reInitSlick() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    onLoaded() {
      this.reInitSlick();
    },

    onLoadError(e) {
      e.target.src = 'https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.webp';
      e.target.classList.add('v-lazy-image-loaded');
    },

    handleAfterChange(_event, _slick, currentSlide) {
      this.$emit('update:indexActive', currentSlide);
    }
  }
};
</script>

<style lang="scss">
.modal__image {
  .modal-content {
    border: none;
    border-radius: 0;
  }
  .modal-body {
    padding: 0;
    background-color: #d9d9d9;
  }
  .slick-dots {
    position: absolute;
    margin-top: 30px;
  }
  .img__item {
    margin-right: auto;
    margin-left: auto;
    max-height: 800px;
    max-width: -moz-available; /* WebKit-based browsers will ignore this. */
    max-width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
    object-fit: cover;
    object-position: center;
  }
  .icon__xmark {
    cursor: pointer;
    position: absolute;
    margin: 7px 10px 0 0;
    color: #3b3e66;
  }
}
</style>
